import { modulesMockHandler } from '@/features/modules';

export const modulesHandlers = [modulesMockHandler];
